import { configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import {
    persistStore,
    persistCombineReducers,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER
} from 'redux-persist';
import { drawerReducer } from "../Layout/Dawer/drawerSlice";
// import AsyncStorage from "@react-native-async-storage/async-storage";
import { authReducer } from "../Features/Shared/Login/LoginSlice";
import { locationsReducer } from "../Features/Shared/Locations/locationSlice";
import { ordersReducer } from "../Features/SalesDep/Orders/OrderSlice";
import { salesReducer } from "../Features/SalesDep/Sales/SalesSlice";
import { bidsReducer } from "../Features/SalesDep/Bids/BidSlice";
// import { templatesReducer } from "Features/Templates/TemplateSlice";
import { customersReducer } from "../Features/Shared/Customers/CustomerSlice";
import { crmReducer } from "../Features/SalesDep/CRM/CRMSlice";
import { accountReducer } from "../Features/Shared/Account/AccountSlice";
import { sellAThonReducer } from "../Features/SalesDep/Sales/SellAThonSlice";
import { todoReducer } from "../Features/SalesDep/To-Do List/TodoSlice";
import { welcomeReducer } from "../Features/Shared/Dashboard/Welcome Modal/WelcomeUISlice";
import { bootstrapReducer } from "./bootstrap/bootstrapSlice";
import { salesRepViewBootstrapReducer } from "./bootstrap/salesRepViewBootstrapSlice";
import { writerReducer } from "../Features/SalesDep/Managers/SalesRepView/WriterSlice";
import { notificationReducer } from "../Features/Shared/Push Notifications/PushNotificationSlice";

const config = {
    key: 'root',
    storage: storage,
    debug: true,
    blacklist: ['auth']
};

export const store = configureStore({
    reducer: persistCombineReducers(config, {
        auth: authReducer,
        locations: locationsReducer,
        orders: ordersReducer,
        sales: salesReducer,
        bids: bidsReducer,
        // templates: templatesReducer,
        customers: customersReducer,
        crm: crmReducer,
        account: accountReducer,
        sellAThon: sellAThonReducer,
        todo:  todoReducer,
        welcomeUI: welcomeReducer,
        drawer: drawerReducer,
        bootstrap: bootstrapReducer,
        salesRepView: salesRepViewBootstrapReducer,
        writer: writerReducer,
        notifications: notificationReducer,
    }),
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
    })
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
